var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrevious({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 25,
    viewBox: "0 0 12 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.69753 24.2099L1.52753 16.0399C1.0619 15.5755 0.692471 15.0237 0.440407 14.4163C0.188342 13.8088 0.0585943 13.1576 0.0585943 12.4999C0.0585942 11.8423 0.188342 11.1911 0.440407 10.5836C0.692471 9.97615 1.0619 9.4244 1.52753 8.95994L9.69753 0.789941C9.88584 0.601637 10.1412 0.495849 10.4075 0.495849C10.6738 0.495849 10.9292 0.601637 11.1175 0.789941C11.3058 0.978244 11.4116 1.23364 11.4116 1.49994C11.4116 1.76624 11.3058 2.02164 11.1175 2.20994L2.94753 10.3799C2.38573 10.9424 2.07017 11.7049 2.07017 12.4999C2.07017 13.2949 2.38573 14.0574 2.94753 14.6199L11.1175 22.7899C11.2113 22.8829 11.2857 22.9935 11.3364 23.1154C11.3872 23.2372 11.4133 23.3679 11.4133 23.4999C11.4133 23.632 11.3872 23.7627 11.3364 23.8845C11.2857 24.0064 11.2113 24.117 11.1175 24.2099C11.0246 24.3037 10.914 24.3781 10.7921 24.4288C10.6703 24.4796 10.5395 24.5057 10.4075 24.5057C10.2755 24.5057 10.1448 24.4796 10.023 24.4288C9.9011 24.3781 9.7905 24.3037 9.69753 24.2099Z",
    fill: "#3A3A3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevious);
export default __webpack_public_path__ + "static/media/Previous.d9e00f97b85df1b2bb7846ad2c48ab35.svg";
export { ForwardRef as ReactComponent };